module.exports = __webpack_public_path__ + "img/HNG-1920.de45522a.jpg";